import React from 'react';
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react';

import clsx from 'clsx';

export function TitlelessDialogBox({open, onClose, panelClass, children}
  : {open: boolean, onClose: (confirmed: boolean) => void, hideCancelButton?: boolean, panelClass?: string, children?: React.ReactNode}
) {

  return (
    <Dialog open={open} onClose={() => onClose(false)} transition className="tw-relative tw-z-50 tw-opacity-100 tw-transition-opacity tw-duration-300 tw-ease-in-out data-[closed]:tw-opacity-0">
      <DialogBackdrop className="tw-fixed tw-inset-0 tw-bg-black/30" />

      <div className="tw-fixed tw-inset-0 tw-w-screen tw-flex tw-items-start tw-justify-center">
        <DialogPanel transition className={ clsx(
            "tw-absolute tw-top-10 tw-w-11/12 tw-max-w-screen-sm",
            // "tw-p-5",
            "tw-bg-white  tw-rounded-md tw-shadow-md tw-shadow-gray-500",
            "tw-transition tw-duration-300 data-[closed]:-tw-translate-y-5", panelClass)}>
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
